import { useLoaderData } from "@remix-run/react";
import { gearsLoader } from "@made-people/gears-remix";
import { TextBlock } from "@made-people/blueprint-text-block";

export const LoadCentraCategoryDescription = () => {
  const { pageResponse } = useLoaderData<typeof gearsLoader>();
  const page = pageResponse?.page;
  const categoryData =
    page?.pageType === "storyblokPage" ? page?.categoryData : undefined;
  const categoryDescription = categoryData?.category_description;

  if (typeof categoryDescription !== "string" || !categoryDescription.trim()) {
    return null;
  }

  return (
    <TextBlock
      layout={{ position: { maxWidth: "md" } }}
      body={categoryDescription}
      variants={{ alignment: "left" }}
      enableTruncate
      truncateRows={2}
    />
  );
};
